import { Routes, RouterModule } from '@angular/router';

import { AdvancePaymentModule } from './AdvancePayment/AdvancePayment.Module';
import { AllergyModule } from './Allergy/Allergy.module';
import { AppointmentsModule } from './Appointments/Appointments.module';
import { DocumentsModule } from './Documents/Documents.module';
import { InsuranceModule } from './Insurance/Insurance.module';
import { LabModule } from './Lab/Lab.module';
import { RadiologyModule } from './Radiology/Radiology.module';
import { ImmunizationModule } from './Immunization/Immunization.module';
import { PrescriptionsModule } from './Prescriptions/Prescriptions.module';
import { ServicePaymentModule } from './ServicePayment/ServicePayment.Module';
import { SearchServicePaymentModule } from './SearchServicePayment/SearchServicePayment.Module';
import { PatientProfileModule } from './PatientProfile/PatientProfile.module';
import { FeedBackModule } from './FeedBack/FeedBack.module';
import { ChangePasswordModule } from './ChangePassword/ChangePassword.module';

import { RegistrationModule } from './Register/Registration.module';
import { ForgotPasswordModule } from './ForgotPassword/ForgotPassword.module';
import { SignUpModule } from './SignUp/SignUp.module';

import { SearchScreenModule } from './SearchScreen/SearchScreen.module';
import { BookingModule } from './Booking/Booking.module';
import { GuestAppointmentModule } from './GuestAppointment/GuestAppointment.Module';
import { GuestAppointmentComponent, LoginComponent, KioskLoginComponent} from "./appindex";
import { DashboardModule } from './Dashboard/Dashboard.module';
import { LoginModule } from './Login/Login.module';
import { KioskLoginModule } from './KioskLogin/KioskLogin.module';
import { ProcedureModule } from '../app/Procedure/Procedure.module';
import { MedicalReportModule } from '../app/MedicalReport/MedicalReport.module';
import { MedicalRequestModule } from '../app/MedicalRequest/MedicalRequest.module';
const routes: Routes = [

    { path: 'Dashboard', loadChildren: () => DashboardModule, data: { breadcrumb: "Dashboard" } },
    { path: 'Lab', loadChildren: () => LabModule, data: { breadcrumb: "Lab" } },
    { path: 'Appointments', loadChildren: () => AppointmentsModule, data: { breadcrumb: "Appointments" } },
    { path: 'Allergy', loadChildren: () => AllergyModule, data: { breadcrumb: "Allergy" } },
    { path: 'Documents', loadChildren: () => DocumentsModule, data: { breadcrumb: "Documents" } },
    { path: 'Insurance', loadChildren: () => InsuranceModule, data: { breadcrumb: "Insurance" } },
    { path: 'Prescriptions', loadChildren: () => PrescriptionsModule, data: { breadcrumb: "Prescriptions" } },
    { path: 'Immunization', loadChildren: () => ImmunizationModule, data: { breadcrumb: "Immunization" } },
    { path: 'Radiology', loadChildren: () => RadiologyModule, data: { breadcrumb: "Radiology" } },
    { path: 'ServicePayment', loadChildren: () => ServicePaymentModule, data: { breadcrumb: "ServicePayment" } },
    { path: 'SearchServicePayment', loadChildren: () => SearchServicePaymentModule, data: { breadcrumb: "SearchServicePayment" } },
    { path: "AdvancePayment", loadChildren: () => AdvancePaymentModule, data: { breadcrumb: "AdvancePayment" } },
    { path: 'Procedure', loadChildren: () => ProcedureModule, data: { breadcrumb: "Procedure" } },
    { path: 'MedicalReport', loadChildren: () => MedicalReportModule, data: { breadcrumb: "MedicalReport" } },
	{ path: 'MedicalRequest', loadChildren: () => MedicalRequestModule, data: { breadcrumb: "MedicalRequest" } },
    { path: 'SearchScreen', loadChildren: () => SearchScreenModule, data: { breadcrumb: "SearchScreen" } },
    { path: 'Booking', loadChildren: () => BookingModule, data: { breadcrumb: "Booking" } },

    { path: 'Registration', loadChildren: () => RegistrationModule, data: { breadcrumb: "Registration" } },
    { path: 'ForgotPassword', loadChildren: () => ForgotPasswordModule, data: { breadcrumb: "ForgotPassword" } },
    { path: 'SignUp', loadChildren: () => SignUpModule, data: { breadcrumb: "SignUp" } },

    { path: 'ChangePassword', loadChildren: () => ChangePasswordModule, data: { breadcrumb: "ChangePassword" } },
    { path: 'FeedBack', loadChildren: () => FeedBackModule, data: { breadcrumb: "FeedBack" } }, 
    { path: 'PatientProfile', loadChildren: () => PatientProfileModule, data: { breadcrumb: "PatientProfile" } },

   { path: 'GuestAppointment', loadChildren: () => GuestAppointmentModule, data: { breadcrumb: "GuestAppointment" } },//For Loading Ondemand or Onclick of Button (Book Appointments)
    { path: 'Login', component: LoginComponent, data: { breadcrumb: "Login" } },
    { path: 'KioskLogin', component: KioskLoginComponent, data: { breadcrumb: "KioskLogin" } },
    { path: '', redirectTo: '/Login', pathMatch: 'full' },
    { path: '**', component: LoginComponent }


];
export const APP_ROUTER_PROVIDERS = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/app.routes.ts